/** Configuración de mantenimiento (`app_config.key = maintenance`). */
export const DEFAULT_MAINTENANCE = {
  enabled: false,
  message: '',
  motivo_interno: '',
  fin_estimado: null,
  sections: {
    marketplace: false,
    subastas: false,
    comunidad: false,
    noticias: false,
    registro_partner: false,
  },
};

export const SECTION_MAINT_KEYS = [
  { key: 'marketplace', label: 'Marketplace' },
  { key: 'subastas', label: 'Subastas' },
  { key: 'comunidad', label: 'Comunidad' },
  { key: 'noticias', label: 'Noticias' },
  { key: 'registro_partner', label: 'Registro Partner' },
];

export const MAINTENANCE_LOG_SECTIONS = [
  { key: '', label: 'Todas las secciones' },
  { key: 'global', label: 'Global' },
  ...SECTION_MAINT_KEYS.map(({ key, label }) => ({ key, label })),
];

export const MAINTENANCE_LOG_ACCIONES = [
  { key: '', label: 'Todas las acciones' },
  { key: 'activado', label: 'Activado' },
  { key: 'desactivado', label: 'Desactivado' },
  { key: 'seccion_activada', label: 'Sección activada' },
  { key: 'seccion_desactivada', label: 'Sección desactivada' },
  { key: 'mensaje_actualizado', label: 'Mensaje actualizado' },
];

/** Ruta interna `page` → clave en `sections`. */
export const PAGE_TO_MAINT_SECTION = {
  marketplace: 'marketplace',
  subastas: 'subastas',
  comunidad: 'comunidad',
  'comunidad-guardados': 'comunidad',
  'grooves-ranking': 'comunidad',
  noticias: 'noticias',
  'registro-tienda': 'registro_partner',
  'partner-registro': 'registro_partner',
};

const SECTION_LABELS = Object.fromEntries(SECTION_MAINT_KEYS.map(({ key, label }) => [key, label]));
SECTION_LABELS.global = 'Global';

export function parseMaintenanceConfig(raw) {
  if (!raw || typeof raw !== 'object') {
    return {
      enabled: DEFAULT_MAINTENANCE.enabled,
      message: DEFAULT_MAINTENANCE.message,
      motivo_interno: DEFAULT_MAINTENANCE.motivo_interno,
      fin_estimado: DEFAULT_MAINTENANCE.fin_estimado,
      sections: { ...DEFAULT_MAINTENANCE.sections },
    };
  }
  const finRaw = raw.fin_estimado;
  let fin_estimado = null;
  if (finRaw) {
    const d = new Date(finRaw);
    if (!Number.isNaN(d.getTime())) fin_estimado = d.toISOString();
  }
  return {
    enabled: !!raw.enabled,
    message: String(raw.message || ''),
    motivo_interno: String(raw.motivo_interno || ''),
    fin_estimado,
    sections: {
      ...DEFAULT_MAINTENANCE.sections,
      ...(raw.sections && typeof raw.sections === 'object' ? raw.sections : {}),
    },
  };
}

/** Una sección está en mantenimiento si el interruptor global está activo y la sección está marcada. */
export function isSectionInMaintenance(cfg, sectionKey) {
  if (!cfg || !sectionKey) return false;
  return !!cfg.enabled && !!cfg.sections?.[sectionKey];
}

export function maintenanceSectionLabel(sectionKey) {
  return SECTION_LABELS[sectionKey] || sectionKey || '—';
}

export function buildMaintenancePayload(cfg) {
  const sections = { ...DEFAULT_MAINTENANCE.sections, ...(cfg?.sections || {}) };
  const anySection = Object.values(sections).some(Boolean);
  let fin_estimado = null;
  if (cfg?.fin_estimado) {
    const d = new Date(cfg.fin_estimado);
    if (!Number.isNaN(d.getTime())) fin_estimado = d.toISOString();
  }
  return {
    enabled: !!cfg?.enabled || anySection,
    message: String(cfg?.message || '').trim(),
    motivo_interno: String(cfg?.motivo_interno || '').trim(),
    fin_estimado,
    sections,
  };
}

/** Texto "Volvemos aproximadamente a las HH:MM" para la pantalla de mantenimiento. */
export function formatMaintenanceFinEstimado(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  if (d.getTime() <= Date.now()) return null;
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `Volvemos aproximadamente a las ${hh}:${mm}`;
}

export function maintenanceFinEstimadoToDatetimeLocal(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function maintenanceDatetimeLocalToIso(local) {
  if (!local || !String(local).trim()) return null;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
